import { render } from "./WhatWeDo.vue?vue&type=template&id=bef721ec"
import script from "./WhatWeDo.vue?vue&type=script&lang=js"
export * from "./WhatWeDo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__